export default "__VITE_ASSET__CWzdE6ne__"